import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-dark py-8 border-t border-white/5 text-center text-gray-500 text-sm px-4" data-id="element-15">
        <p className="mb-2" data-id="element-16">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
        <p data-id="element-17">
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <p className="mt-4" data-id="element-18">
          Descargo de responsabilidad: Los resultados pueden variar. Esta guía
          proporciona información educativa y no constituye asesoramiento
          financiero o legal profesional.
        </p>
        <div className="mt-6 flex items-center justify-center gap-4" data-id="element-19">
          <button onClick={() => setActiveModal('terms')} className="hover:text-gold-primary transition-colors" data-id="element-20">
            Términos
          </button>
          <span className="text-white/20" data-id="element-21">|</span>
          <button onClick={() => setActiveModal('privacy')} className="hover:text-gold-primary transition-colors" data-id="element-22">
            Privacidad
          </button>
        </div>
      </footer>

      {/* Terms Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-23">
        <p data-id="element-24">
          <strong data-id="element-25">Última actualización:</strong> Marzo 2026
        </p>

        <h3 className="text-white font-bold text-lg mt-2" data-id="element-26">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-27">
          Al acceder y utilizar este sitio web y adquirir nuestros productos
          digitales, usted acepta estar sujeto a estos Términos y Condiciones.
          Si no está de acuerdo con alguna parte de estos términos, no debe
          utilizar nuestro sitio.
        </p>

        <h3 className="text-white font-bold text-lg mt-2" data-id="element-28">
          2. Producto Digital
        </h3>
        <p data-id="element-29">
          El producto ofrecido es una guía digital educativa en formato PDF.
          Este material es de carácter informativo y educativo. No constituye
          asesoramiento fiscal, financiero o legal profesional. Usted es
          responsable de consultar con un profesional calificado antes de tomar
          decisiones fiscales.
        </p>

        <h3 className="text-white font-bold text-lg mt-2" data-id="element-30">
          3. Entrega del Producto
        </h3>
        <p data-id="element-31">
          Una vez completado el pago, recibirá acceso inmediato al producto
          digital. Debido a la naturaleza digital del producto, todas las ventas
          son finales y no se ofrecen reembolsos.
        </p>

        <h3 className="text-white font-bold text-lg mt-2" data-id="element-32">
          4. Propiedad Intelectual
        </h3>
        <p data-id="element-33">
          Todo el contenido de este sitio y del producto digital está protegido
          por derechos de autor. Queda prohibida la reproducción, distribución o
          reventa del material sin autorización expresa por escrito.
        </p>

        <h3 className="text-white font-bold text-lg mt-2" data-id="element-34">
          5. Limitación de Responsabilidad
        </h3>
        <p data-id="element-35">
          Los resultados mencionados son ejemplos y pueden variar según la
          situación individual de cada contribuyente. No garantizamos resultados
          específicos. El uso de la información proporcionada es bajo su propia
          responsabilidad.
        </p>

        <h3 className="text-white font-bold text-lg mt-2" data-id="element-36">6. Modificaciones</h3>
        <p data-id="element-37">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor inmediatamente después
          de su publicación en el sitio.
        </p>
      </LegalModal>

      {/* Privacy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-38">
        <p data-id="element-39">
          <strong data-id="element-40">Última actualización:</strong> Marzo 2026
        </p>

        <h3 className="text-white font-bold text-lg mt-2" data-id="element-41">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-42">
          Recopilamos información personal que usted nos proporciona
          voluntariamente al realizar una compra, incluyendo: nombre, dirección
          de correo electrónico e información de pago. La información de pago es
          procesada de forma segura por nuestro procesador de pagos y no
          almacenamos datos de tarjetas de crédito.
        </p>

        <h3 className="text-white font-bold text-lg mt-2" data-id="element-43">
          2. Uso de la Información
        </h3>
        <p data-id="element-44">
          Utilizamos su información personal para: procesar su compra y entregar
          el producto digital, enviar confirmaciones de compra, y mejorar
          nuestros productos y servicios. No vendemos, alquilamos ni compartimos
          su información personal con terceros con fines de marketing.
        </p>

        <h3 className="text-white font-bold text-lg mt-2" data-id="element-45">
          3. Cookies y Tecnologías de Seguimiento
        </h3>
        <p data-id="element-46">
          Utilizamos cookies y tecnologías similares para mejorar la experiencia
          del usuario, analizar el tráfico del sitio y para fines publicitarios.
          Puede configurar su navegador para rechazar cookies, aunque esto
          podría afectar la funcionalidad del sitio.
        </p>

        <h3 className="text-white font-bold text-lg mt-2" data-id="element-47">4. Seguridad</h3>
        <p data-id="element-48">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger su información personal contra acceso no autorizado,
          alteración, divulgación o destrucción.
        </p>

        <h3 className="text-white font-bold text-lg mt-2" data-id="element-49">5. Sus Derechos</h3>
        <p data-id="element-50">
          Usted tiene derecho a acceder, corregir o eliminar su información
          personal. Para ejercer estos derechos, puede contactarnos a través de
          los medios proporcionados en este sitio.
        </p>

        <h3 className="text-white font-bold text-lg mt-2" data-id="element-51">
          6. Cambios a esta Política
        </h3>
        <p data-id="element-52">
          Nos reservamos el derecho de actualizar esta política de privacidad en
          cualquier momento. Le notificaremos sobre cambios significativos
          publicando la nueva política en este sitio.
        </p>
      </LegalModal>
    </>;
}